import isEqual from "lodash.isequal";
import { ChangeEvent } from "react";

import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import {
  IntNullableFilter,
  ModelOrderByWithRelationInput,
  ModelWhereInput,
} from "@/generated/graphql-hooks";

type ModelNumericFilterProps = {
  filterList: { label: string; value: IntNullableFilter }[];
  name: "height" | "weight";
};

export const ModelNumericFilter = ({
  filterList,
  name,
}: ModelNumericFilterProps) => {
  const { query, setWhere } = useRequestQuery<
    ModelWhereInput,
    ModelOrderByWithRelationInput
  >();

  const onSetFilter = (e: ChangeEvent<HTMLInputElement>) => {
    const { [name]: _, ...rest } = query.where;

    if (!e.target.checked) {
      setWhere(rest);
      return;
    }

    setWhere({ ...rest, [name]: JSON.parse(e.target.value) });
  };

  return (
    <div className="space-y-3">
      {filterList.map(({ label, value }, index) => (
        <label className="flex items-center space-x-3" key={index}>
          <input
            type="radio"
            name={name}
            value={JSON.stringify(value)}
            checked={isEqual(query?.where?.[name], value)}
            className="form-radio text-primary h-4 w-4 rounded-full border-gray-500 bg-transparent !ring-0 !ring-offset-0"
            onChange={onSetFilter}
          />
          <span className="text-base font-light text-gray-900">{label}</span>
        </label>
      ))}
    </div>
  );
};
